module.exports = __webpack_public_path__ + "static/record-shift-hours-b5f7f2ed0a5433db0aaf8649e3458c70.png";